import { useEffect, useState } from "react"
import API from "../../utils/API"
import Sweetalert from "../../utils/Sweetalert"
import ButtonCollapse from "../ButtonCollapse"
import LoadingCard from "../LoadingCard"
import DiffusionAdCanvaCardItem from "./DiffusionAdCanvaCardItem"
import { openSchedulerModal } from "./Scheduler/SchedulerModal"

export default function DiffusionAdCanvaCard({ setCurrentAdPath, totemSelected, addAdToSelectedTotem }) {
  // State
  const [canvaItems, setCanvaItems] = useState(null)
  const [canvaPath, setCanvaPath] = useState([{ id: "root", name: "Canva" }])
  const [continuation, setContinuation] = useState(null)
  const [loaded, setLoaded] = useState(false)

  // Comportements
  const getCanvaItems = () => {
    API.GET(
      `/canva/items?folderId=${canvaPath[canvaPath.length - 1].id}${
        continuation ? `&continuation=${continuation}` : ""
      }`,
      (response) => {
        if (continuation) setCanvaItems([...canvaItems, ...response.data.items])
        else setCanvaItems(response.data.items)

        if (response.data.continuation) setContinuation(response.data.continuation)
        else setContinuation(null)

        setLoaded(true)
      }
    )
  }

  useEffect(() => {
    getCanvaItems()
  }, [canvaPath])

  const handleClick = (item) => {
    if (item.type) {
      if (item.type === "folder") {
        setCanvaPath([...canvaPath, { id: item.folder.id, name: item.folder.name }])
        setCanvaItems(null)
        setLoaded(false)
      } else {
        selectItem(item)
      }
    } else {
      // Bouton retour ou autre lien direct de remontée
      const itemIndex = canvaPath.findIndex((path) => path.id === item.id)
      if (itemIndex !== -1) {
        setCanvaPath(canvaPath.slice(0, itemIndex + 1))
        setCanvaItems(null)
        setLoaded(false)
      }
    }
  }

  const selectItem = async (item) => {
    let maxDuration = totemSelected.team_totem.duration
    let sendRequest = async (item, nVDuration, mediaType) => {
      if (nVDuration > maxDuration)
        Sweetalert.fireWarningToast(
          "Vous dépassez la limite de " + maxDuration + "s de diffusion par boucle autorisée pour ce totem"
        )
      else {
        // We want to add scheduler modal here for now
        const planification = await openSchedulerModal()

        if (planification === false) return

        setLoaded(false)

        Sweetalert.fireInfo(
          "Diffusion de la ressource",
          "La récupération du média de Canva peut prendre plusieurs secondes, veuillez patienter..."
        )

        API.POST(
          "/totem/" + totemSelected.id + "/ad_canva",
          {
            id: item[item.type].id,
            duration: nVDuration,
            mediaType,
            canvaItem: item,
            planification,
          },
          (response) => {
            Sweetalert.fireSuccessToast(response.data.message)
            addAdToSelectedTotem(response.data.ad, nVDuration, planification)
            setLoaded(true)
          }
        )
      }
    }

    let mediaType = "image"

    if (item.type === "design") {
      mediaType = await Sweetalert.askMediaType()
      if (!mediaType) return
    }

    if (mediaType === "image")
      Sweetalert.askNumber(
        "Durée d'affichage",
        "Définissez la durée pendant laquelle cette ressource s'affiche par boucle",
        1,
        maxDuration,
        `Durée en secondes (Entre 1 et ${maxDuration}s)`,
        (response) => sendRequest(item, parseInt(response.value), mediaType)
      )
    else sendRequest(item, 0, mediaType)
  }

  // Rendu
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Mes ressources Canva</h3>
        <div className="card-tools">
          <ButtonCollapse />
        </div>
      </div>
      <div className="card-body p-0" style={{ display: "block" }}>
        <LoadingCard loaded={loaded}>
          {totemSelected ? (
            <>
              <div
                className="m-3"
                onClick={() => {
                  if (canvaPath.length > 1) handleClick(canvaPath[canvaPath.length - 2])
                  else setCurrentAdPath(null)
                }}
              >
                <button type="button" className="btn btn-block btn-light p-0">
                  <div className="info-box bg-transparent mb-0 p-0">
                    <div className="info-box-content">
                      <div className="d-flex justify-content-between">
                        <span
                          style={{
                            maxWidth: "60%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <i className="fas fa-chevron-left"></i> <b>Retour</b>
                        </span>
                        <span>
                          <em>Dossier</em>
                        </span>
                      </div>
                    </div>
                  </div>
                </button>
              </div>

              {canvaItems &&
                canvaItems.map((item) => <DiffusionAdCanvaCardItem item={item} onClick={() => handleClick(item)} />)}
            </>
          ) : (
            <div className="alert alert-info m-3">
              <i className="icon fas fa-info" /> Veuillez sélectionner un totem
            </div>
          )}
        </LoadingCard>
      </div>
    </div>
  )
}
